import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ForsorjningskallaAggregat } from "~app/common/models/forsorjningskalla";
import { CommandService } from "~app/common/services/cqs/command.service";
import { RemoveForsorjningskallaLevorderCommand } from "../../kundorder/common/remove-forsorjningskalla";
import { LeverantorsorderradAggregat } from "../leverantorsorder-details/leverantorsorder-leveransrader/leverantorsorderradAggregat";

@Component({
    selector: "rask-leveransrader-edit",
    templateUrl: "./leveransrader-edit.component.html",
    styleUrls: ["./leveransrader-edit.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ButtonComponent]
})
export class LeveransraderEditComponent {
    forsorjningskallaAggregat: ForsorjningskallaAggregat;
    leverantorsorderradAggregat: LeverantorsorderradAggregat;
    modal = inject(NgbActiveModal);

    private readonly commandService = inject(CommandService);

    dismiss(): void {
        this.modal.dismiss();
    }

    remove(): void {
        const command = new RemoveForsorjningskallaLevorderCommand(c => {
            c.kundorderradId = this.forsorjningskallaAggregat.id;
            c.leverantorsorderradId = this.leverantorsorderradAggregat.orderradId;
        });
        this.commandService.addTransactionCommand(command);
        this.leverantorsorderradAggregat.removeForsorjningskalla(this.forsorjningskallaAggregat);
        this.modal.close(true);
    }
}
